export enum UserRole {
  Admin = 'admin',
  Monocolist = 'monocolist',
  Banned = 'banned',
}

export enum UserSubscriptionTier {
  Free = 'free',
  Paid = 'paid',
  Enterprise = 'enterprise',
}

export enum SubscriptionEntitlement {
  /// Able to scan and upload objects.
  ObjectScanning = 'object_scanning',

  /// Able to sign in to the Gallery website
  /// and see all uploaded bundles.
  MonocleGallery = 'monocle_gallery',

  /// Able to capture and upload monocle videos.
  MonocleVideoCapture = 'monocle_video_capture',

  /// Able to access the xMeet Room Designer (beta)
  XMeetRoomDesigner = 'xmeet_room_designer',

  /// Able to process prime jobs.
  PrimeJobsProcessing = 'prime_jobs_processing',

  /// Able to directly upload bundle / model data.
  BundleUpload = 'bundle_upload',

  // For advanced scanning workflow where the user
  // uploads DSLR images after initial scan
  KeepPrimeJobData = 'keep_prime_job_data',
}
